import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportItemsOnHireData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [customerOptions, setCustomerOptions] = React.useState<GenericListItem[]>([]);
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/Customer/GetCustomersForDropdown?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    setCustomerOptions(res.data);
                    setLoading(false);
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const runReport = (e: any) => {
        e.preventDefault();

        //run the report and export the data
        runRpt();
    }
 
    const runRpt = async() => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios('api/Report/RunItemsOnHireReport?subId=' + user.sub + '&CustomerId=' + customerId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Items On Hire.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    const renderDetails = (
        <div>
            <div className="marginBottom20">
                <h1>Items On Hire Currently Report</h1>
                <div>This report will show all jobs installed on site. Select customer if you wish to filter the report by customer.</div>
            </div>
            <div>
                <label className="input-group" htmlFor="customerId">
                    <span className="label">Customer</span>
                    <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => setCustomerId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {customerOptions.map(cust =>
                            <option key={cust.id} value={cust.id}>{cust.name}</option>
                        )};
                    </select>
                </label>
            </div>
            <div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportItemsOnHireData;